import { render, staticRenderFns } from "./NoAuth.vue?vue&type=template&id=456755a6&scoped=true&"
import script from "./NoAuth.vue?vue&type=script&lang=js&"
export * from "./NoAuth.vue?vue&type=script&lang=js&"
import style0 from "./NoAuth.vue?vue&type=style&index=0&id=456755a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456755a6",
  null
  
)

export default component.exports